import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-leaves-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, AddPopupComponent, FontAwesomeModule],
  templateUrl: './leaves-table.component.html',
  styleUrl: './leaves-table.component.css'
})
export class LeavesTableComponent implements OnInit, OnChanges {
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showModal = false;
  isEditMode = false;
  showDeleteModal = false;
  showSkeleton = true;
  @Input() leaves: any[] = [];
  @Input() loading = false;
  @Output() addLeave = new EventEmitter<{ formValue: any, compulsory: boolean, gender: any, teamLeadAction: any }>();
  @Output() editLeave = new EventEmitter<{ id: any, formValue: any, compulsory: boolean, gender: any, teamLeadAction: any }>();
  @Output() deleteLeave = new EventEmitter<any>();
  leaveForm: FormGroup;
  selectedLeaveId: number | null = null;
  compulsoryLeave = false;
  genderApplicability:  number | null = null;
  teamLeadActionType: any = null;
  leaveToDeleteId: number | null = null;

  constructor(private fb: FormBuilder) {
    this.leaveForm = this.fb.group({
      leave_name: ['', Validators.required],
      leave_count: ['', Validators.required],
      leave_type: [null, Validators.required],
      gender_applicability: [null, Validators.required]
    });
  }

  ngOnChanges() {
    if (this.loading) {
      this.showTableLoader();
    }
  }
  ngOnInit(): void {
    this.showTableLoader();
  }
  skeletonRows: any[] = [];
  skeletonCols: any[] = [];

  showTableLoader(duration = 800) {
    this.showSkeleton = true;

    const rowCount = this.leaves?.length || 5;
    const columnCount = 6; // 👈 match your table columns

    this.skeletonRows = Array(rowCount).fill(0);
    this.skeletonCols = Array(columnCount).fill(0);

    setTimeout(() => {
      this.showSkeleton = false;
    }, duration);
  }

  toggleModal() {
    this.showModal = !this.showModal;

    if (!this.showModal) {
      this.leaveForm.reset({
        leave_name: '',
        leave_count: '',
        leave_type: null
      });
      this.isEditMode = false;
      this.selectedLeaveId = null;
      this.compulsoryLeave = false;
      this.genderApplicability = null;
      this.teamLeadActionType = null;
    }
  }


  openAddModal() {
    this.isEditMode = false;
    this.toggleModal();
  }

  openEditModal(item: any) {
    this.isEditMode = true;
    this.selectedLeaveId = item.id;
    this.leaveForm.patchValue({
      leave_name: item.leave_name,
      leave_count: item.leave_count,
      leave_type: item.leave_type,
      gender_applicability: item.gender_applicability
    });
    this.compulsoryLeave = item.compulsary_leave == 1;
    // this.genderApplicability = item.gender_applicability;
    this.teamLeadActionType = item.team_lead_action_type;
    this.showModal = true;
  }

  onSave() {
    debugger
    if (this.leaveForm.valid) {
      const formData = this.leaveForm.value;
      if (this.isEditMode && this.selectedLeaveId !== null) {
        this.editLeave.emit({
          id: this.selectedLeaveId,
          formValue: formData,
          compulsory: this.compulsoryLeave,
          gender: formData.gender_applicability,
          teamLeadAction: this.teamLeadActionType
        });
      } else {
        this.addLeave.emit({
          formValue: formData,
          compulsory: this.compulsoryLeave,
          gender: formData.gender_applicability,
          teamLeadAction: this.teamLeadActionType
        });
      }
      this.toggleModal();
    }
  }

  openDeleteModal(id: number) {
    this.leaveToDeleteId = id;
    this.showDeleteModal = true;
  }

  confirmDelete() {
    if (this.leaveToDeleteId !== null) {
      this.deleteLeave.emit(this.leaveToDeleteId);
    }
    this.closeDeleteModal();
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.leaveToDeleteId = null;
  }

  toggleCompulsoryLeave(event: any) {
    this.compulsoryLeave = event.target.checked;
  }

  
changeGenderApplicability(value: any) {
  debugger
  console.log('Changed to:', value);
  this.genderApplicability = value; // optional, already updated by [(ngModel)]
}

  changeTeamLeadAction(value: any) {
    this.teamLeadActionType = value;
  }

  getTotalPaidCount(): number {
    const list = this.leaves ?? [];
    return list
      .filter(l => l?.leave_type && (l.leave_type as string).toLowerCase() === 'paid')
      .reduce((sum, l) => sum + (Number(l?.leave_count) || 0), 0);
  }

  getTotalUnpaidCount(): number {
    const list = this.leaves ?? [];
    return list
      .filter(l => l?.leave_type && (l.leave_type as string).toLowerCase() === 'unpaid')
      .reduce((sum, l) => sum + (Number(l?.leave_count) || 0), 0);
  }

  getTotalLeavesCount(): number {
    const list = this.leaves ?? [];
    return list.reduce((sum, l) => sum + (Number(l?.leave_count) || 0), 0);
  }
}
